/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteEmployeeRole} from '../api'

export const useMutationDeleteEmployeeRole = createReactQueryMutationHook('deleteEmployeeRole', deleteEmployeeRole)
